export default "__VITE_ASSET__BDJeiKPg__"